var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('navbar'),_c('div',{staticClass:"wrapper__content"},[_c('sidebar'),_c('div',{staticClass:"main-content"},[(_vm.title)?_c('div',{staticClass:"text-2xl text-grey-dark"},[_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")]):_vm._e(),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }